// extracted by mini-css-extract-plugin
export default {"cls1":"c6WBffqNlnWXNbPFE7po","cls2":"gF_7S1Bnp6Ql7nMmzapv c6WBffqNlnWXNbPFE7po","hasWhiteBackground":"t5A22wMfcTomYxhRMvQD"};